import * as React from "react";
const SvgShieldCheck = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.50004 8.99997L7.16671 10.6666L10.5 7.33331M14.6667 8.99997C14.6667 12.7176 10.1167 15.4114 8.53456 16.2358C8.36343 16.325 8.27786 16.3695 8.15917 16.3926C8.06671 16.4106 7.93337 16.4106 7.84091 16.3926C7.72222 16.3695 7.63665 16.325 7.46552 16.2358C5.88334 15.4114 1.33337 12.7176 1.33337 8.99997V5.84797C1.33337 5.18171 1.33337 4.84858 1.44234 4.56223C1.5386 4.30926 1.69503 4.08354 1.89809 3.90458C2.12795 3.70201 2.43987 3.58504 3.06371 3.3511L7.53188 1.67554C7.70512 1.61057 7.79175 1.57808 7.88086 1.56521C7.9599 1.55379 8.04018 1.55379 8.11922 1.56521C8.20834 1.57808 8.29496 1.61057 8.4682 1.67554L12.9364 3.3511C13.5602 3.58504 13.8721 3.70201 14.102 3.90458C14.3051 4.08354 14.4615 4.30926 14.5577 4.56223C14.6667 4.84858 14.6667 5.18171 14.6667 5.84797V8.99997Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgShieldCheck;
